import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import NavigationService from '../services/navigation.service';

/**
 * Hook to register navigation function with the NavigationService
 * This allows non-React code (like axios interceptors) to trigger navigation
 */
export const useNavigationSetup = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Register the navigate function
        NavigationService.setNavigate(navigate);

        // Cleanup on unmount
        return () => {
            NavigationService.clear();
        };
    }, [navigate]);
};
